export const checkPermissionAndNavigate = (
  pathname,
  userDetailsObject,
  navigate,
) => {
  const restrictedPaths = [
    {
      path: '/nomination-administration',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/nomination-secretary',
      allowedRoles: ['admin', 'super-admin', 'secretary'],
    },
    {
      path: '/nominations',
      allowedRoles: ['fellow', 'super-admin'],
    },
    {
      path: '/assessor-administration',
      allowedRoles: ['admin', 'committee-chair', 'super-admin'],
    },
    {
      path: '/committees',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/elect-candidate',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/candidates',
      allowedRoles: [
        'admin',
        'committee-chair',
        'committee-member',
        'super-admin',
        'secretary',
        'council-observer',
        'council-member',
      ],
    },
    {
      path: '/coi-report',
      allowedRoles: [
        'admin',
        'committee-chair',
        'super-admin',
        'secretary',
        'council-observer',
        'council-member',
      ],
    },
    {
      path: '/candidate-scores',
      allowedRoles: [
        'admin',
        'committee-chair',
        'super-admin',
        'secretary',
        'council-observer',
        'council-member',
      ],
    },
    {
      path: '/scoring-completion',
      allowedRoles: [
        'admin',
        'committee-chair',
        'super-admin',
        'secretary',
        'council-observer',
        'council-member',
      ],
    },
    {
      path: '/pre-nomination-steps',
      allowedRoles: ['super-admin'],
    },
    {
      path: '/referee',
      allowedRoles: ['super-admin', 'referee'],
    },
    {
      path: '/referee-administration',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/referee-archive',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/settings',
      allowedRoles: ['super-admin'],
    },
    {
      path: '/admin-actions',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/application',
      allowedRoles: ['fellow', 'super-admin'],
    },
    {
      path: '/secretaries-and-council-members',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/ranked-candidates',
      allowedRoles: [
        'admin',
        'super-admin',
        'secretary',
        'committee-chair',
        'council-member',
      ],
    },
    {
      path: '/council-member-allocations',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/referee-report-extension-requests',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/nomination-history',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/cron-job-monitor',
      allowedRoles: ['admin', 'super-admin'],
    },
    {
      path: '/secretary-actions',
      allowedRoles: ['secretary'],
    },
  ];

  const isPathRestricted = restrictedPaths.some(
    (item) => item.path === pathname,
  );

  if (isPathRestricted) {
    const { allowedRoles } = restrictedPaths.find(
      (item) => item.path === pathname,
    );
    const hasAccess = allowedRoles.some((role) =>
      userDetailsObject.roles.includes(role),
    );

    const allowedRoute = restrictedPaths.find((item) =>
      item.allowedRoles.some((value) =>
        userDetailsObject.roles.includes(value),
      ),
    );

    const allowedPath = allowedRoute ? allowedRoute.path : '/permission-denied';

    if (!hasAccess) {
      navigate(allowedPath);
    }
  }
};
